import React, { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Question } from '@/components/head/question/index.jsx';
import { TitleH2 } from '@/components/head/titleH2/index.jsx';
import { SecondOption } from '@/components/ui/option/secondOption/index.jsx';
import { Range } from '@/components/ui/range/index.jsx';
import styles from './home.module.scss';
import { UsequestionsState } from '@/store/atoms/questionsState';
import { Button } from '../ui/button';
import { useInputValuesState } from '../../store/atoms/inputValuesState';

export const QuestionPage = memo(() => {
  const { setInputValues, inputValues, currentNum, setCurrentNum } =
    useInputValuesState();
  const { list } = UsequestionsState();
  const navigate = useNavigate();
  useEffect(() => {
    console.log('list', list.length);
    setInputValues(
      Array(list.length)
        .fill()
        .map((e, index) => ({ id: index, term_id: null, name: '', num: 0 }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentNum >= list.length) {
      navigate('/result');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNum]);

  const onClickprev = () => {
    console.log(currentNum);
    setInputValues(
      inputValues.map((inputValue, index) =>
        index === currentNum - 1
          ? { id: index, term_id: null, name: '', num: 0 }
          : inputValue
      )
    );
    setCurrentNum(currentNum - 1);
  };

  return (
    <>
      {currentNum < list.length && (
        <div className={styles.inner}>
          <Range num={list[currentNum].id} totalNum={list.length} />
          <TitleH2>{Object.values(list[currentNum].cat.name)}の質問</TitleH2>
          <div className={`${styles.divider} ${styles.use_sp}`}></div>
          <Question
            title={list[currentNum].question}
            number={list[currentNum].id}
          />
          <SecondOption
            options={list[currentNum].answers}
            type={list[currentNum].cat}
            total={list.length}
          />
          {inputValues[0].term_id && (
            <Button title={'一つ前へ戻る'} click={onClickprev} />
          )}
        </div>
      )}
    </>
  );
});
